/**
 * Converts minor units back to major units.
 *
 * @param minorUnits - Amount in minor units (e.g., 1050 cents)
 * @param decimals - Number of decimal places in the currency (default: 2)
 * @returns Amount in major units (e.g., 10.50 dollars)
 *
 * @example
 * fromMinorUnits(1050, 2)   // 10.50 (USD)
 * fromMinorUnits(1050, 0)   // 1050 (JPY)
 * fromMinorUnits(10500, 3)  // 10.500 (KWD)
 */
export const fromMinorUnits = (minorUnits: number, decimals: number = 2): number => {
  const divisor = Math.pow(10, decimals);

  return minorUnits / divisor;
};
